import { Routes, RouterModule } from '@angular/router';
import { ExpOrgExtScreenComponent } from './exp-org/exp-org.component';
import { AccountExtScreenComponent } from './account/account.component';
import { ProjectTaskExtScreenComponent } from './project-task/project-task.component';
import { ExpTypeExtScreenComponent } from './exp-type/exp-type.component';
import { OebsConfigExtScreenComponent } from './oebs-config/oebs-config.component';
import { AuthGuard } from 'src/commons';
import { CompanyExtScreenComponent } from './company/company.component';
import { AccountingDistributionExternalScreenComponent } from './accounting-distribution-external.component';

const accountingDistributionExternalRoutes: Routes = [
];

export const AccountingDistributionExternalRouter = RouterModule.forChild(accountingDistributionExternalRoutes);